import { deflectionActivityQuery } from "../lib/deflectionActivityQuery"
import { useDashboardQuery } from "./useDashboardQuery"

export function useDeflectionActivityQuery(...args: Parameters<typeof deflectionActivityQuery>) {
  return useDashboardQuery(deflectionActivityQuery(...args))
}
